import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../context/ProtectedRoute';
import SimulationLibrary from '../projects/ESID-25-006/pages/simulationlibrary';
import DispatchResults from '../projects/ESID-25-006/pages/dispatchresults';
import BESSRevenueOverview from '../projects/ESID-25-006/pages/bessrevenueoverview';

function WDPRoutes({setLoading, triggerAlert}) {
  return (
    <Routes>
      <Route path="dashboard" element={
        <ProtectedRoute project="esid-25-006">
          <SimulationLibrary setLoading={setLoading} triggerAlert={triggerAlert}/>
        </ProtectedRoute>
      } />
      <Route path="dispatchresults" element={
        <ProtectedRoute project="esid-25-006">
          <DispatchResults setLoading={setLoading} triggerAlert={triggerAlert}/>
        </ProtectedRoute>
      } />
      <Route path="bessrevenueoverview" element={
        <ProtectedRoute project="esid-25-006">
          <BESSRevenueOverview setLoading={setLoading} triggerAlert={triggerAlert}/>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default WDPRoutes;